import React from 'react';
import withIcon from '../utilities/withIcon';

const IconPrinter = () => {
  return (
    <g>
      <path d="m3.55 0 8.902.018c.54.001.985.41 1.042.936l.006.114v2.948l1.451.003c.541 0 .986.41 1.043.935L16 5.07v6.381c0 .541-.41.987-.936 1.044l-.114.006-1.45-.001v2.451c0 .541-.41.987-.936 1.044L12.45 16h-8.9a1.05 1.05 0 0 1-1.044-.936L2.5 14.95v-2.451l-1.45.001a1.05 1.05 0 0 1-1.044-.936L0 11.45v-6.4c0-.54.41-.986.936-1.043L1.051 4l1.449.002V1.05c0-.542.41-.987.936-1.044L3.55 0zM4 10.002V14.5h8v-4.483l-8-.016zm-2.5-4.5V11h1V9.55c0-.54.41-.986.936-1.043L3.55 8.5l8.902.017c.54.001.985.41 1.042.936l.006.114V11h1V5.517l-13-.016zM3 6.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5zm1-4.749v2.503l8 .01V1.517l-8-.016z" />
    </g>
  );
};

export default withIcon(IconPrinter);
